import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Loader from '../components/Loader';
import { useSettings } from '../context/SettingsContext';

const About = () => {

    const [aboutBanner, setAboutBanner] = useState(null);
    const [aboutPageContent, setAboutPageContent] = useState(null);
    const { renderHTML } = useSettings();

    const getAboutBanner = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}get-content/aboutusPageBanner`);
            setAboutBanner(res.data.data[0])
        } catch (err) {
            console.error('Error fetching Banner Content:', err);
        }
    }

    const getAboutPageContent = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}get-content/aboutusPage`);
            setAboutPageContent(res.data.data)
        } catch (err) {
            console.error('Error fetching Page Content:', err);
        }
    }

    useEffect(() => {
        getAboutBanner();
        getAboutPageContent();
    }, [])

    if (aboutBanner === null || aboutPageContent === null) {
        return <Loader />
    }

    return (
        <>
            <section className="inner-banner" style={{ backgroundImage: `url(${process.env.REACT_APP_SITE_IMAGES}${aboutBanner.image_2})` }}>
                <div className="container-fluid web-padding">
                    <div className="row">
                        <div className="col-md-6" data-aos="fade-right" data-aos-duration={1000}>
                            <div className="inner-banner-left">
                                <h1>{aboutBanner.title}</h1>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="inner-banner-right">
                                <img src={`${process.env.REACT_APP_SITE_IMAGES}${aboutBanner.image}`} alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
                <h2>Tyres</h2>
            </section>
            <div className="about-inner-wrapper">
                <section className="about-us">
                    <div className="container all-section">
                        <div className="row">
                            <div className="col-md-5" data-aos="fade-right" data-aos-duration={1000}>
                                <div className="about-top-left">
                                    <h2>{aboutPageContent[0].title}</h2>
                                    {renderHTML(aboutPageContent[0].details)}
                                </div>
                            </div>
                            <div className="col-md-7" data-aos="fade-left" data-aos-duration={1000}>
                                <div className="about-top-right">
                                    <img src={`${process.env.REACT_APP_SITE_IMAGES}${aboutPageContent[0].image}`} alt={aboutPageContent[0].title} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-5" data-aos="fade-right" data-aos-duration={1000}>
                                <div className="about-bottom-left">
                                    <img src={`${process.env.REACT_APP_SITE_IMAGES}${aboutPageContent[1].image}`} alt={aboutPageContent[1].title} />
                                </div>
                            </div>
                            <div className="col-md-7" data-aos="fade-left" data-aos-duration={1000}>
                                <div className="about-bottom-right">
                                    <h2>{aboutPageContent[1].title}</h2>
                                    {renderHTML(aboutPageContent[1].details)}
                                </div>
                            </div>
                        </div>
                    </div>
                    <h2 data-aos="fade-down" data-aos-duration={1000}>About Us</h2>
                </section>
            </div>
        </>
    )
}

export default About